import React, { useState } from "react";
import { Layers } from "lucide-react";
import { formatMoney, formatNumber } from "../../lib/api";

export function Pregunta({ icon: Icon, titulo, texto, si, no, onSi, testid }) {
  return (
    <div className="card p-6 border-l-4 border-l-sky-500 flex items-center gap-4 flex-wrap" data-testid={testid}>
      <div className="w-11 h-11 rounded-full bg-sky-50 text-sky-700 flex items-center justify-center shrink-0"><Icon size={20} /></div>
      <div className="flex-1 min-w-[220px]">
        <div className="font-display text-lg font-bold">{titulo}</div>
        <p className="text-sm text-slate-500">{texto}</p>
      </div>
      <div className="flex gap-2">
        <button onClick={onSi} className="btn btn-primary" data-testid={`${testid}-si`}>{si}</button>
        {no}
      </div>
    </div>
  );
}

export function Familias({ rows, onPick }) {
  const [abierto, setAbierto] = useState(false);
  const tv = rows.reduce((t, f) => t + (f.ventas_eur || 0), 0);
  const tc = rows.reduce((t, f) => t + (f.coste_ventas || 0), 0);
  const ts = rows.reduce((t, f) => t + (f.stock_pvp || 0), 0);
  const totM = tv ? (100 * (tv - tc)) / tv : null;
  const totR = ts ? tv / ts : null;
  if (!abierto) {
    return <Pregunta icon={Layers} testid="la-pregunta-familias" titulo="¿Quieres ver el stock por familias de este laboratorio?"
                     texto={`Este laboratorio vende en ${rows.length} ${rows.length === 1 ? "familia" : "familias"}. Pulsa una para ver su ABCD y su stock parado.`}
                     si="Sí, ver familias" onSi={() => setAbierto(true)} />;
  }
  return (
    <div className="card p-6" data-testid="la-familias">
      <h3 className="font-display text-lg font-bold">Stock por familias</h3>
      <p className="text-xs text-slate-500 mb-3">Pulsa una familia para analizar solo esa parte del laboratorio. En rojo, margen o rotación por debajo de la media del laboratorio.</p>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-[11px] uppercase tracking-wider text-slate-500 border-b">
            <th className="py-2 pr-3">Familia</th><th className="num">Refs</th><th className="num">Uds stock</th><th className="num">Stock (coste)</th>
            <th className="num">Stock (PVP)</th><th className="num">Ventas</th><th className="num">Margen</th><th className="num">Rotación</th><th className="num">Parado (D)</th></tr></thead>
          <tbody>
            {rows.map((f) => {
              const m = f.ventas_eur ? (100 * (f.ventas_eur - f.coste_ventas)) / f.ventas_eur : null;
              const r = f.stock_pvp ? f.ventas_eur / f.stock_pvp : null;
              return (
              <tr key={f.familia} onClick={() => onPick(f.familia)} className="border-b border-slate-100 hover:bg-sky-50 cursor-pointer transition-colors" data-testid={`la-familia-${f.familia}`}>
                <td className="py-2 pr-3 font-semibold text-sky-800">{f.familia}</td>
                <td className="num">{formatNumber(f.refs)}</td><td className="num">{formatNumber(f.stock_uds)}</td>
                <td className="num">{formatMoney(f.stock_coste)}</td><td className="num">{formatMoney(f.stock_pvp)}</td><td className="num">{formatMoney(f.ventas_eur)}</td>
                <td className={"num font-semibold " + (m != null && totM != null && m < totM ? "text-red-600" : "text-emerald-700")}>{m == null ? "—" : `${m.toFixed(1).replace(".", ",")} %`}</td>
                <td className={"num font-bold " + (r != null && totR != null && r < totR ? "text-red-600" : "text-emerald-700")}>{r == null ? "—" : `${r.toFixed(2).replace(".", ",")}×`}</td>
                <td className="num text-red-600 font-semibold">{formatMoney(f.d_coste)}</td>
              </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
